import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Select,
  Tag,
  Divider,
  Image,
  Spin,
  Row,
  Col,
  PageHeader,
  Modal,
  Drawer,
  Tooltip,
} from "antd";
import Highlighter from "react-highlight-words";
import {
  EditOutlined,
  EyeOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  SearchOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import _, { sortBy } from "lodash";
import moment from "moment";
import { connect } from "react-redux";
import { ViewPrevetiveDetails } from "../viewPreventive/viewPreventive";
import { ViewGunaDetails } from "../viewGunaDetails/viewGunaDetails";
import { ImageView } from "../image/imageView";
import { LanguageContext } from "../../context/LanguageContext";
import { professionalAction } from "../../_actions";
const { Option } = Select;
class TableCrimeList extends React.Component {
  static contextType = LanguageContext;
  state = {
    imageOpen: false,
    selectedImage: null,
    showGunaDetails: false,
    gunaLoading: false,
    preventiveLoading: false,
    showCountDetails: false,
    districtId: "",
    countDetails: [],
    selectOption: {},
    crime_id: "",
  };

  handleActiveCriminal = (data) => {
    this.props.onCriminalActiveStatus(data);
  };

  handleMobile = (record) => {
    this.props.handleMultipleMobile(record);
  };

  handelSelectOption = (value, record) => {
    this.setState(
      (prev) => ({
        selectOption: { ...prev.selectOption, [record.id]: value },
      }),
      () => {
        if (value === "preventive") {
          this.handlePreventiveViewForm(record.id);
        }
        if (value === "crNumber") {
          this.handleNCrNumberViewForm(record.id);
        }
        if (value == "mobile") {
          this.handleMobile(record.id);
        }
        if (value == "document") {
          this.openDocumentVerified(record.id);
        }
        // ⭐ IMPORTANT: Reset dropdown back to "select"
        this.setState((prev) => ({
          selectOption: { ...prev.selectOption, [record.id]: "select" },
        }));
      }
    );
  };

  showGunaViewModel = () => {
    this.setState({
      showGunaDetails: true,
    });
  };

  closeGunaViewModel = () => {
    this.setState({
      showGunaDetails: false,
    });
  };
  showpreventiveViewModel = () => {
    this.setState({
      showpreventive: true,
    });
  };
  closepreventiveViewModel = () => {
    this.setState({
      showpreventive: false,
      selectOption: {}, // RESET ALL dropdown values
    });
  };

  openDocumentVerified = (id) => {
    this.props.openDocumentVerified(id);
  };

  showCountDetailsModel = (districtId) => {
    this.setState(
      {
        showCountDetails: true,
        districtId: districtId,
      },
      () => {
        if (this.props.condition != "तडीपार") {
          // ✅ Call wantedInfo after state is updated
          this.wantedInfo();
        }
      }
    );
  };

  onGunaForm = (data) => {
    if (data) {
      this.setState({ gunaLoading: true });
      this.showGunaViewModel();
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };
  componentDidUpdate(prevProps) {
    // Check if the data has just arrived
    const prevList = prevProps.professionals?.criminalViewList?.gunhaInfor;
    const currList = this.props.professionals?.criminalViewList?.gunhaInfor;
    if (this.state.gunaLoading && prevList !== currList) {
      this.setState({ gunaLoading: false });
    }
    const prevPrevetive = prevProps.professionals?.criminalViewList;
    const currtPrevetive = this.props.professionals?.criminalViewList;
    if (this.state.preventiveLoading && prevPrevetive !== currtPrevetive) {
      this.setState({ preventiveLoading: false });
    }
  }

  openImageModal = (img, name, id) => {
    this.setState({
      imageOpen: true,
      selectedImage: img,
      name: name,
      crime_id: id,
    });
  };

  closeImageModal = () => {
    this.setState({ imageOpen: false, selectedImage: null, name: null });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "", sortBy: "" });
  };

  handleViewForm = (data) => {
    console.log("data", data);
    this.props.onViewAccusedDetails(data);
  };
  handleEditForm = (data) => {
    this.props.onEditAccusedForm(data);
  };

  handlePreventiveViewForm = (data) => {
    this.props.onPreventiveViewAccusedForm(data);
  };
  handleNCrNumberViewForm = (data) => {
    this.props.onNCRViewAccusedForm(data);
  };

  render() {
    console.log("this.props.is_search", this.props.is_search);
    const verification = localStorage.getItem("allocatedVerification") || "";
    const { language, t } = this.context;
    let tempColumns = [];
    const { professionals, user } = this.props;
    const { selectOption } = this.state;

    if (verification !== undefined && verification !== "") {
      try {
        var allocatedVerification = JSON.parse(verification);

        if (allocatedVerification?.plan === "Plan C") {
          var appUsers = localStorage.getItem("appUsers");
        }
      } catch (error) {}
    } else {
    }
    console.log("allocatedVerification", allocatedVerification);
    let columnsOb = [
      {
        title: t("sr.no"),
        key: t("sr.no"),
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.srNo}
          </Space>
        ),
      },
      {
        title: t("name_of_the_accused"),
        key: "name",
        dataIndex: "name",
        render: (text, record) => (
          <Space size="middle" title={record?.id} style={{ maxWidth: 300 }}>
            {record.name}
          </Space>
        ),
      },
      {
        title: t("accused_police_station"),
        key: "districtName",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.districtName}
          </Space>
        ),
      },
      {
        title: t("total_crimes"),
        key: "gunhaCount",
        sorter: {
          compare: (a, b) =>
            (a.totalCrimeCount ?? a.gunhaCount) -
            (b.totalCrimeCount ?? b.gunhaCount),
        },
        render: (text, record) => (
          <div>
            <Button
              type="primary"
              shape="circle"
              size="small"
              style={{
                width: 36,
                height: 36,
                fontWeight: 600,
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              }}
              onClick={() => {
                this.onGunaForm(record.id);
              }}
            >
              {record.totalCrimeCount
                ? record.totalCrimeCount
                : record.gunhaCount}
            </Button>
          </div>
        ),
      },

      {
        title: t("photo"),
        key: "Photo",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {this.props.is_search && record.image ? (
              <>
                <img
                  style={{ width: 50, height: 50 }}
                  src={
                    "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                    record.image
                  }
                  onClick={() =>
                    this.openImageModal(record.image, record.name, record.id)
                  }
                ></img>
              </>
            ) : record.photo &&
              record.photo.length > 0 &&
              record.photo[0] != "" ? (
              <>
                <img
                  style={{ width: 50, height: 50 }}
                  src={
                    "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                    record.photo[0]
                  }
                  onClick={() =>
                    this.openImageModal(record.photo[0], record.name, record.id)
                  }
                ></img>
              </>
            ) : (
              "नाही"
            )}
          </Space>
        ),
      },
      {
        title: t("action"),
        key: "action",
        render: (text, record) => (
          <>
            <div className="gov-action-wrapper">
              <Space size="middle">
                {this.props.user.role !== "12" && (
                  <Tooltip title="Update Record">
                    <Button
                      type="primary"
                      icon={<EditOutlined />}
                      className="gov-btn-update"
                      onClick={() => this.handleEditForm(record)}
                    >
                      {t("update")}
                    </Button>
                  </Tooltip>
                )}

                {this.props.user.role === "2" && (
                  <Select
                    className="gov-select"
                    onChange={(e) => this.handelSelectOption(e, record)}
                    value={this.state.selectOption[record.id] || "select"}
                  >
                    <Select.Option value="select" disabled>
                      निवडा
                    </Select.Option>
                    <Select.Option value="preventive">
                      {t("preventive")}
                    </Select.Option>
                    <Select.Option value="crNumber">
                      {t("crNumber")}
                    </Select.Option>
                    <Select.Option value="mobile">
                      <span style={{ whiteSpace: "normal" }}>
                        {t("multiple_mobile")}
                      </span>
                    </Select.Option>
                    <Select.Option
                      value="document"
                      disabled={
                        !allocatedVerification ||
                        (allocatedVerification?.plan !== "Plan A" &&
                          allocatedVerification?.plan !== "Plan B")
                      }
                    >
                      ओळखपत्र जोडा
                    </Select.Option>
                  </Select>
                )}
                <Tooltip title="View Details">
                  <Button
                    icon={<EyeOutlined />}
                    className="gov-btn-view"
                    onClick={() => this.handleViewForm(record.id)}
                  >
                    {t("view1")}
                  </Button>
                </Tooltip>
              </Space>
            </div>

            {/* <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => this.handlePreventiveViewForm(record.id)}
            >
              {t("preventive")}
            </Button> */}
            {/* {user.cityId === record.city ? (
              this.props.report == true ? (
                ""
              ) : this.props.user.role === "9" ||
                this.props.user.role === "10" ? (
                ""
              ) : (
                <Button
                  type="text"
                  size="small"
                  className="action-link update-link"
                  onClick={() => {
                    this.handleActiveCriminal(record);
                  }}
                >
                  {record.activeUser && record.activeUser === 1 ? (
                    <Tag color="green">{t("active")} </Tag>
                  ) : (
                    <Tag color="red">{t("in_active")}</Tag>
                  )}
                </Button>
              )
            ) : (
              ""
            )} */}
          </>
        ),
      },
    ];

    let tebleData =
      this.props.data &&
      this.props.data.map((item, index) => {
        return {
          ...item,
          srNo: this.props.getSerialNumber(
            index,
            this.props.current,
            this.props.pageSize
          ),
        };
      });

    return (
      <>
        <Table
          bordered
          loading={this.props.loading}
          key={
            this.props.selectedOption === "data_entered_by_police_station" &&
            tebleData
          }
          columns={columnsOb}
          dataSource={tebleData}
          pagination={{
            current: this.props.current + 1,
            pageSize: this.props.pageSize,
            total: this.props.total,
            onChange: this.props.handlePageChange,
            onShowSizeChange: this.props.handlePageSizeChange,
            showSizeChanger: true,
          }}
          rowClassName={() => "govt-table-row"}
        />

        {this.state.imageOpen && (
          <ImageView
            imageOpen={this.state.imageOpen}
            imageUrl={
              "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
              this.state.selectedImage
            }
            name={this.state.name}
            onClose={this.closeImageModal}
            id={this.state.crime_id}
          />
        )}
        <Modal
          title={t("crime_information")}
          top
          visible={this.state.showGunaDetails}
          onOk={this.closeGunaViewModel}
          onCancel={this.closeGunaViewModel}
          width={95 + "%"}
        >
          <ViewGunaDetails
            pc_crimetitles={professionals?.pc_crimetitles}
            dataStates={
              Array.isArray(professionals?.criminalViewList?.gunhaInfor) &&
              professionals?.criminalViewList?.gunhaInfor.length > 0
                ? professionals?.criminalViewList?.gunhaInfor
                : []
            }
            name={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].name
                : ""
            }
            address={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].address
                : ""
            }
            loading={this.state.gunaLoading}
            user_details={this.props?.user}
            masterId={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].id
                : ""
            }
            closeGunaViewModel={this.closeGunaViewModel}
          ></ViewGunaDetails>
        </Modal>
        <Modal
          title={t("preventive_action")}
          top
          visible={this.state.showpreventive}
          onOk={this.closepreventiveViewModel}
          onCancel={this.closepreventiveViewModel}
          width={95 + "%"}
        >
          <ViewPrevetiveDetails
            preventiveAction={this.state?.preventiveAction}
            dataStates={
              Array.isArray(
                this.props.professionals?.criminalViewList?.preventiveInfo
              ) &&
              this.props.professionals?.criminalViewList?.preventiveInfo
                .length > 0
                ? this.props.professionals?.criminalViewList?.preventiveInfo
                : []
            }
            name={
              Array.isArray(
                this.props.professionals?.criminalViewList?.basicInfo
              ) && this.props.professionals?.criminalViewList?.basicInfo[0]
                ? this.props.professionals?.criminalViewList?.basicInfo[0].name
                : ""
            }
            loading={this.statepreventiveLoading}
          ></ViewPrevetiveDetails>
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedTableCrime = connect(mapStateToProps)(TableCrimeList);
export { connectedTableCrime as TableCrimeList };
